import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HttpBackend, HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { httpErrorInterceptor } from './core/interceptors/http-error.interceptor';
import { keycloakInterceptor } from './core/interceptors/keycloak.interceptor';

// store
import { provideStore } from '@ngrx/store';
import { indexReducer } from './store/index.reducer';

// shared module
import { SharedModule } from 'src/shared.module';

// i18n
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { routes } from './app.route';
import { provideFlatpickrDefaults } from 'angularx-flatpickr';
import { AutoRefreshTokenService, provideKeycloak, UserActivityService, withAutoRefreshToken } from 'keycloak-angular';
import { environment } from '../environments/environment';

// AOT compilation support
export function HttpLoaderFactory(httpHandler: HttpBackend): TranslateHttpLoader {
    return new TranslateHttpLoader(new HttpClient(httpHandler));
}

export function getBaseUrl() {
    return document.getElementsByTagName('base')[0].href;
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
        provideAnimations(),
        provideHttpClient(withInterceptors([keycloakInterceptor, httpErrorInterceptor])),
        provideStore({ index: indexReducer }),
        provideFlatpickrDefaults(),
        provideKeycloak({
            config: {
                url: environment.keycloak.url,
                realm: environment.keycloak.realm,
                clientId: environment.keycloak.clientId,
            },
            initOptions: {
                onLoad: 'login-required',
                checkLoginIframe: false
            },
            features: [
                withAutoRefreshToken({
                    sessionTimeout: 60 * 60 * 1000,
                }),
            ],
            providers: [AutoRefreshTokenService, UserActivityService],
        }),
        importProvidersFrom(
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpBackend],
                },
            }),
            SharedModule.forRoot()
        ),
        { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
        Title,
    ]
};
